import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

export function apiUrl(path: string): string {
  return `http://localhost:3000/api/${path}`;
}

export function getReadableRole(role: string): string {
  switch (role) {
    case "group_coach":
      return "ryhmävalmentaja";
    case "individual_coach":
      return "yksilövalmentaja";
    case "work_coach":
      return "työvalmentaja";
    case "customer":
      return "asiakas";
    case "associate":
      return "verkostokäyttäjä";
    case "administrator":
      return "järjestelmänvalvoja";
    case "supervisor":
      return "esihenkilö";
    default:
      return role;
  }
}
